<template>
    <div>
        <button class="button xs is-coolGreen is-small has-text-weight-bold" :disabled="$parent.$parent.$parent.editMode" :class="{bundleTNFollow: !inModal}" @click="toggleFollow">
            <span class="red is-size-5 top-1">{{$parent.item.fState ? '&bull;' : ''}}</span>{{$parent.item.fState ? 'unfollow' : 'follow'}}
        </button>
        <div v-show="reason">
            <div class="followReasonDiv" :class="{inTN: !inModal}">
                <div><b>Tell us Why?</b></div>
                <div class="followReason" @click="r(1, $event)">Admire</div>
                <div class="followReason" @click="r(2, $event)">Interest</div>
                <div class="followReason" @click="r(3, $event)">Research</div>
                <div class="followReason" @click="r(4, $event)">Work</div>
                <div class="followReason" @click="r(5, $event)">Other</div>
            </div>
        </div>
    </div>
</template>
<script>

import { AZEventBus } from '../components/AZEventBus'
export default {
    props: {
        inModal:{
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            reason: false,
            fState: null,
            fid: null,
            pubId: null
        }
    },
    mounted: function() {
       AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)

    },

    beforeDestroy: function(){
        AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

    methods: {

        closeAllMenusHandler: function(msg){
            this.reason = false   
        },

        r: function(id, ev){
            ev.stopPropagation()
            //send to backend

            this.reason = false
        },

        toggleFollow: function(ev){
            var self = this;
            ev.stopPropagation()

          

            if(this.$parent.item.fState){
               
                this.$parent.item.fState = false
            } else {
                if(self.$root.app.isAuth == false){
                    self.$root.app.showModalLogin({message: 'reloadPage'})
                    return
                }
                if(self.$root.app.userAttrs.profile == null){
                    self.$root.app.showModalOK({message: 'Please complete your public profile before following a bundle. Select "Profile" from the My Accounts menu.'})
                    return
                }
                this.$parent.item.fState = true
            }

            function w(d){
                let retId
                if(d.retId == 'updated' || d.retId == null){
                    retId = 'updated'                  
                } else {
                    self.fid = d.retId  
                    retId = d.retId                 
                }

                if(self.$parent.item.fState){
                  self.reason = true
                }

                if(self.inModal){
                   
                    //call function on profile to update TN
                    self.$root.app.$refs.routerView.updateTN(self.$parent.item.pubId, retId, self.$parent.item.fState)
                } else {
                    //set fid, fState of parent
                    if(retId != 'updated')
                        self.$parent.item.fid = retId

                    self.$parent.item.fState = self.$parent.item.fState
                }

                
            }

            function n(){

            }

            this.$root.app.apiClient.put('subs/data/follow', {id: this.$parent.item.pubId, action: this.$parent.item.fState}, w, n)

        },

        r: function(why, ev){
            ev.stopPropagation()
            this.reason = false
            var self = this;
            function w(d){

            }
            function n(){

            }
            self.$root.app.apiClient.put('subs/data/followreason', {fid: self.fid, why: why}, w, n)
        }
    },
}
</script>